export default __webpack_public_path__ + "static/media/caveTubing2.29479590.webp";